<template>
<div>
   <div class="addGoods">
    <div class="goods_batch_weight goods_input">
      <span class="good_label">
        货品名称
        <!-- <span>(必填)</span> -->
      </span>
      <div class="good_input">
        <input
          type="text"
          v-model="subData.name"
          placeholder="请输入的货品名称,例如苹果、香蕉"
          style="width: 100%;"
        />
      </div>
    </div>

       <div class="goods_batch_unit goods_btn">
      <span class="good_label">
        商品分类 
      </span>
       <div class="good_pack goods_btns">
        <span
          v-for="(item,index) in goodsTypeList"
          :key="index"
          :class="subData.cate_id == item.id?'active':''"
          @click="selectGoodsType(item)"
        >{{item.name}}</span>
      </div>
    
    </div>
    
    <div class="goods_batch_pack goods_btn">
      <span class="good_label">进货包装</span>
      <div class="good_pack goods_btns">
        <span
          v-for="(item,index) in pack_list"
          :key="index"
          :class="subData.bale == item.value?'active':''"
          @click="subData.bale = item.value"
        >{{item.name}}</span>
      </div>
    </div>

 
  
       <div class="goods_batch_unit goods_btn" v-if="subData.bale == 1 || subData.bale == 2">
      <span class="good_label">进货单位</span>
      <div class="good_pack goods_btns">
        <span
          v-for="(item,index) in unit_list"
          :key="index"
          :class="subData.num_unit == item.value?'active':''"
          @click="subData.num_unit = item.value"
        >{{item.name}}</span>
      </div>
    </div>
    <div class="goods_batch_weight goods_input" v-if="subData.bale == 1">
      <span class="good_label">
        规格
        <!-- <span>(必填)</span> -->
      </span>
      <div class="good_input2">
        <KeyBoardInput
          :k_default_show="false"
          :k_isValueZero="false"
          v-model="subData.bale_num"
          :k_decimal="3"
        >
          <template slot="input_right">公斤 / {{unit_list[subData.num_unit-1].name}}</template>
        </KeyBoardInput>
      </div>
      <!-- <div class="good_input">
        <input type="number" v-model="subData.bale_num" :min="0.00" :step="0.01" />
        <span>公斤 / {{unit_list[subData.num_unit-1].name}}</span>
      </div>-->
    </div>
   
    <div class="goods_batch_weight goods_input" v-if="subData.bale == 1 || subData.bale == 2">
      <span class="good_label">
        进货数量
        <!-- <span>(必填)</span> -->
      </span>
      <div class="good_input2">
        <KeyBoardInput
          :k_default_show="false"
          :k_isValueZero="false"
          v-model="subData.num"
          :k_decimal="2"
        >
          <template slot="input_right">{{unit_list[subData.num_unit-1].name}}</template>
        </KeyBoardInput>
      </div>
      <!-- <div class="good_input">
        <input type="number" v-model="subData.num" :min="0.00" :step="0.01" />
        <span>{{unit_list[subData.num_unit-1].name}}</span>
      </div>-->
    </div>
    <div class="goods_batch_weight goods_input" v-if="subData.bale == 2 || subData.bale == 3">
      <span class="good_label">
        进货重量
        <!-- <span>(必填)</span> -->
      </span>
      <div class="good_input2">
        <KeyBoardInput
          :k_default_show="false"
          :k_isValueZero="false"
          v-model="subData.weight"
          :k_decimal="3"
        >
          <template slot="input_right">公斤</template>
        </KeyBoardInput>
      </div>
      <!-- <div class="good_input">
        <input type="number" v-model="subData.weight" :min="0.00" :step="0.01" />
        <span>公斤</span>
      </div>-->
    </div>
    <div class="goods_batch_weight goods_input">
      <span class="good_label">
        货款金额
        <!-- <span>(必填)</span> -->
      </span>
      <div class="good_input2">
        <KeyBoardInput
          :k_default_show="false"
          :k_isValueZero="false"
          v-model="subData.amount"
          :k_decimal="2"
        >
          <template slot="input_right">元</template>
        </KeyBoardInput>
      </div>
      <!-- <div class="good_input">
        <input type="number" v-model="subData.price" :min="0.00" :step="0.01" />
        <span>元 / {{subData.bale != 1?'公斤':unit_list[subData.num_unit-1].name}}</span>
      </div>-->
    </div>
    <div class="goods_batch_weight goods_input">
      <span class="good_label">销售价</span>
      <div class="good_input2">
        <KeyBoardInput
          :k_default_show="false"
          :k_isValueZero="true"
          v-model="subData.proposed_price"
          :k_decimal="2"
        >
          <template slot="input_right">
            <div v-if="subData.bale == 1">元/{{unit_list[subData.num_unit-1].name}}</div>
            <div v-if="subData.bale == 4">元/个</div>
            <div v-if="subData.bale == 2 || subData.bale == 3">元/公斤</div>
          </template>
        </KeyBoardInput>
      </div>
    </div>
    <div class="addition_boxs">
      <div class="addition">
        <div class="addition_title">产品附加费</div>
        <van-button icon="plus" class="add_btn_small" type="primary" plain @click="addAddition">添加</van-button>
      </div>
      <div>
        <div class="addition_box" v-for="(kitem,ki) in subData.surcharge" :key="ki">
          <van-row class="addition_line">
            <van-col span="4" class="addition_left">名称</van-col>
            <van-col span="20" class="addition_right">
              <input
                type="text"
                v-model="kitem.name"
                placeholder="请输入10位以内的附加费名称"
                style="width: 100%;"
              />
            </van-col>
          </van-row>
          <van-row class="addition_line">
            <van-col span="4" class="addition_left">价格</van-col>
            <van-col span="20" class="addition_right">
              <input type="number" v-model="kitem.price" step="0.01" min="0" />
              <span>元</span>
            </van-col>
          </van-row>
          <div style="text-align:right;padding-bottom:0.2rem">
            <van-button class="add_btn_del" type="primary" plain @click="delAddition(ki)">删除</van-button>
          </div>
        </div>
      </div>
      <div class="addition_empty" v-if="!subData.surcharge.length">暂无附加费数据</div>
    </div>

    <div class="good_save" @click="setData">确 认</div>
    
  </div>
  <!-- <van-action-sheet v-model="showMenu" cancel-text="取消"  description="不选择分类,将划分商品为未分类商品"
  close-on-click-action :actions="goodsTypeList" @select="onSelect" /> -->
</div>
 
</template>

<script>
import { goods_type_list } from "@/api/work/manage/goodsManage.js";

import KeyBoardInput from "@/components/KeyBoardInput";
export default {
  name: "addGoods",
  components: {
    KeyBoardInput
  },
  data() {
    return {
      showMenu:false,
    
      goodsTypeList: [],
      pack_list: [
        { value: 1, name: "定装" },
        { value: 2, name: "非定装" },
        { value: 3, name: "散装" }
      ],

      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],

      subData: {
        name: "", //货品名称
        bale: "1", // 销售包装 正装
        unit: 2, //1斤，2公斤。添加时必填 默认为2
        num_unit: 1, // 单位
        num: "", // 数量
        bale_num: "", // 规格 bale==1 必传
        weight: "", // 销售重量
        amount: "", //总价
        price: "", // 单价
        proposed_price: "", // 销售价
        cate_id: "0",
        surcharge: [],
        goodsTypeName:"未分类",
      }
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   if (to.query.type == "editGoods") {
  //     to.meta.title = "编辑货品";
  //   } else {
  //     to.meta.title = "添加货品";
  //   }
  //   next();
  // },
  created() {
    if (this.$route.meta.backData) {
      delete this.$route.meta.backData;
    }
    if (this.$route.query.type) {
      this.subData = JSON.parse(this.$route.query.goods);
      // console.log(JSON.parse(this.$route.query.goods))
    }
    this.getGoodsTypeList();
  },
  mounted() {},
  methods: {
    selectGoodsType(obj){
      this.subData.goodsTypeName=obj.name
this.subData.cate_id=obj.id
    },
    //商品分类
    getGoodsTypeList() {
      goods_type_list().then(res => {
        if (res.code == 200) {
          let goodsTypeArr = res.data.slice();
           this.goodsTypeList =[{name:"未分类",id:"0"}].concat(goodsTypeArr) ;
         
          // console.log(goodsTypeArr)
        }
      });
    },
    //删除附加费
    delAddition(i) {
      this.$dialog
        .confirm({
          title: "删除附加费",
          message: `确定删除产品${this.subData.surcharge[i].name}附加费吗?`
        })
        .then(() => {
          let arr = this.subData.surcharge.slice();
          arr.splice(i, 1);
          this.subData.surcharge = arr;
        })
        .catch(() => {
          // on cancel
        });
    },
    // 添加附加费
    addAddition() {
      this.subData.surcharge.push({
        name: "",
        price: "",
        type: 3
      });
    },
    // 返回增加库存界面
    setData() {
      if (!this.subData.name) {
        this.$toast("请输入货品名称！");
        return false;
      }
      if (this.subData.bale == 1 && !(this.subData.bale_num > 0)) {
        this.$toast("请输入货品规格！");
        return false;
      }
      if (
        this.subData.bale == 1 &&
        !(Number(this.subData.num).toFixed(2) > 0)
      ) {
        this.$toast("请输入货品进货数量！");
        return false;
      }
      if (
        this.subData.bale == 2 &&
        !(Number(this.subData.num).toFixed(2) > 0)
      ) {
        this.$toast("请输入货品进货数量！");
        return false;
      }
      if (
        this.subData.bale == 2 &&
        !(Number(this.subData.weight).toFixed(3) > 0)
      ) {
        this.$toast("请输入货品进货重量！");
        return false;
      }
      if (
        this.subData.bale == 3 &&
        !(Number(this.subData.weight).toFixed(3) > 0)
      ) {
        this.$toast("请输入货品进货重量！");
        return false;
      }
      if (!(Number(this.subData.amount).toFixed(2) > 0)) {
        this.$toast("请输入货款金额！");
        return false;
      }
      let arr = JSON.parse(JSON.stringify(this.subData.surcharge));
      for (let i = 0; i < arr.length; i++) {
        if (
          (!arr[i].name.trim() && arr[i].price.trim()) ||
          (arr[i].name.trim() && !arr[i].price.trim())
        ) {
          this.$toast("请完善产品附加费!");
          return false;
        } else if (!arr[i].name.trim() && !arr[i].price.trim()) {
          arr.splice(i, 1);
          i--;
        } else if (arr[i].name.length > 10) {
          this.$toast("请精简附加费名称!");
          return false;
        }
      }
      this.subData.surcharge = arr;
    
      var subData = JSON.parse(JSON.stringify(this.subData));
      subData.weight = Number(Number(subData.weight).toFixed(3));
      subData.bale_num = Number(Number(subData.bale_num).toFixed(3));
      subData.num = Number(Number(subData.num).toFixed(3));
      subData.amount = Number(Number(subData.amount).toFixed(3));
      if (subData.bale == 1) {
        subData.price = Math.ceil((subData.amount * 100) / subData.num) / 100;
      } else {
        subData.price =
          Math.ceil((subData.amount * 100) / subData.weight) / 100;
      }

      if (subData.bale == 1) {
        subData.weight = subData.bale_num * subData.num;
      }
  
      this.$route.meta.backData = JSON.stringify(subData);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.addGoods {
  .goods_type_box{
    display: flex;
    align-items: center;
  }
  .selcet_btn{
    flex-grow: 1;
    margin-left: 0.2rem;
    line-height: 0.6rem;
    border:1px solid #ccc;
    border-radius: 3px;
    padding: 0 0.3rem;
    justify-content: space-between;

    display: flex;
    align-items: center;
  }
  .addition_boxs {
    .addition_box {
      margin-left: 0.5rem;
      border-top: 1px solid rgba(204, 204, 204, 1);
      &:nth-child(1) {
        border-top: none;
      }
    }

    .add_btn_del {
      height: 0.5rem;
      background: rgba(251, 83, 83, 1);
      border: 1px solid rgba(251, 83, 83, 1);
      border-radius: 0.04rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    .addition_line {
      margin: 0.2rem 0;
      .addition_left {
        font-size: 0.32rem;
        line-height: 0.7rem;
      }
      .addition_right {
        display: flex;
        align-items: center;
        height: 0.7rem;
        input {
          width: 100%;
          text-align: right;
          background-color: transparent;
        }
        border: 1px solid #cccccc;
        padding: 0 0.1rem;
        font-size: 0.32rem;
        line-height: 0.5rem;
      }
    }

    .addition_empty {
      font-size: 0.38rem;
      text-align: center;
      font-weight: 500;
      color: rgba(153, 153, 153, 1);
      line-height: 0.8rem;
      letter-spacing: 0.1rem;
    }
    .addition {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #cccccc;
      padding-bottom: 0.26rem;
      .addition_title {
        font-size: 0.34rem;
        color: rgba(51, 51, 51, 1);
      }
      .add_btn_small {
        border-radius: 0.06rem;
        height: 0.6rem;
        line-height: 0.6rem;
      }
    }
  }
  position: relative;
  min-height: calc(100vh - 0.88rem);
  background-color: #fff;
  padding: 0 0.3rem 1.5rem;
  box-sizing: border-box;
  & > div {
    overflow: hidden;
  }
  .good_label {
    font-size: 0.34rem;
    color: #333;
    line-height: 0.6rem;
    span {
      font-size: 0.28rem;
      color: #fb5353;
    }
  }
  .goods_btn {
    padding-bottom: 0.15rem;
    border-bottom: 0.01rem solid #e6e6e6;
    margin-bottom: 0.15rem;
    .goods_btns {
      margin-top: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      span {
        display: flex;
        align-items: center;
        height: 0.6rem;
        padding: 0 0.4rem;
        background-color: #e6e6e6;
        border-radius: 0.3rem;
        text-align: center;
        margin-right: 0.2rem;
        color: #999;
        letter-spacing: 0.05rem;
        margin-bottom: 0.1rem;
        &.active {
          background: rgba(49, 177, 88, 0.2);
          color: #31b158;
        }
      }
    }
  }
  .goods_batch_other {
    border-bottom: 0.01rem solid #e6e6e6;
    padding-bottom: 0.18rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .good_sel {
      font-size: 0.32rem;
    }
  }
  .goods_batch_type {
    padding-top: 0.18rem;
    margin-bottom: 0.18rem;
    .good_cli {
      font-size: 0.32rem;
      color: #999999;
      .van-icon-arrow {
        vertical-align: text-bottom;
      }
    }
  }
  .goods_input {
    padding-bottom: 0.2rem;
    .good_input2 {
      border: 0.01rem solid #ccc;
      overflow: hidden;
      border-radius: 0.1rem;
      background-color: #f5f5f5;
      display: flex;
      padding-right: 0.15rem;
      justify-content: flex-end;
    }
    .good_input {
      position: relative;
      box-sizing: border-box;
      height: 0.82rem;
      background-color: #f5f5f5;
      border: 0.01rem solid #ccc;
      border-radius: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      input {
        width: 70%;
        line-height: 0.8rem;
        font-size: 0.34rem;
        text-indent: 0.2rem;
        border-radius: 0.1rem;
        background-color: #f5f5f5;
        box-sizing: border-box;
      }
      span {
        line-height: 0.8rem;
        padding-right: 0.2rem;
      }
    }
  }
  .good_save {
    background-color: #31b158;
    text-align: center;
    line-height: 0.8rem;
    margin-top: 0.5rem;
    font-size: 0.36rem;
    color: #fff;
    letter-spacing: 0.1rem;
    border-radius: 0.1rem;
    &[disabled] {
      background-color: #b3b3b3;
    }
  }
}
</style>
